import React, { useState, useContext, useEffect } from 'react'
import CommunicationContext from '../../../../product/context/communication/communicationContext'
import FullScreenPopup from '../../../../product/components/organisms/FullScreenPopup'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { mapData } from '../../../../product/common/components'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'

const CommunicationForm = (props) => {
    const { t } = useTranslation()
    const communicationContext = useContext(CommunicationContext)
    const [isLoading, setIsLoading] = useState(true)
    const { single_template, getSingleTemplate, templateAction } =
        communicationContext
    const data = props.data
    const formik = useFormik({
        initialValues: props.initialValues,
        validateOnBlur: false,
        enableReinitialize: true,
        validationSchema: props.validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            templateAction(values)
        },
    })
    useEffect(() => {
        // props.resetFrom()

        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    }, [props])

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            getSingleTemplate(formik.values)
        } else {
            props.resetFrom()
        }
    }, [data.id])

    useEffect(() => {
        props.editFunctionHandler(single_template)
    }, [single_template])

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? t('ADD NEW TEMPLATE')
                    : `EDIT TEMPLATE: ${single_template.record.title}`
            }
            open={
                data.status === 'new' || data.status === 'edit'
                    ? data.popup
                    : false
            }
            handleClose={() => props.toggleFullScreenPopup(false)}
            disableEnforceFocus={true}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        {isLoading && <div>Loading....</div>}
                        {!isLoading &&
                            ((data.status === 'edit' &&
                                formik.values.template) ||
                                data.status !== 'edit') && (
                                <>
                                    <div className="row">
                                        {formik.values &&
                                        formik.values.method === 'email'
                                            ? Object.values(
                                                  mapData({
                                                      formik: formik,
                                                      data: props.emailTemplate,
                                                  })
                                              )
                                            : Object.values(
                                                  mapData({
                                                      formik: formik,
                                                      data: props.smsTemplate,
                                                  })
                                              )}
                                    </div>
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <SecondaryButton
                                            id="communicationForm_Cancel"
                                            label={t('Cancel')}
                                            onClick={() =>
                                                props.toggleFullScreenPopup(
                                                    false
                                                )
                                            }
                                        />
                                        <PrimaryButton
                                            id="communication_submit"
                                            type="submit"
                                            label={t('Submit')}
                                        />
                                    </div>
                                </>
                            )}
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default CommunicationForm
